import {
    Component,
    InputSignal,
    ModelSignal,
    OutputEmitterRef,
    input,
    model,
    output, ChangeDetectionStrategy
} from "@angular/core";
import {SelectorType} from "./selector";
import {NgClass} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {TouchableDirective} from '../../ui-elements/touchable.directive';
import {ActivatableDirective} from '../../ui-elements/activatable.directive';

@Component({
    selector: "woa-selector-control",
    templateUrl: "./selector-control.component.html",
    styleUrl: "./selector-control.component.scss",
    host: {
        "[class.disabled]": "disabled()",
        "[class.touched]": "touched()"
    },
    imports: [
        NgClass,
        TouchableDirective,
        TranslateModule,
        ActivatableDirective
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectorControlComponent {
    SelectorType = SelectorType;

    public readonly type: InputSignal<SelectorType> = input<SelectorType>(SelectorType.CHECKBOX);
    public readonly label: InputSignal<string> = input<string>();
    public readonly translationParams: InputSignal<Record<string, string | number>> = input<Record<string, string | number>>({});
    public readonly disabled: InputSignal<boolean> = input<boolean>(false);
    public readonly touched: InputSignal<boolean> = input<boolean>(false);

    public selected: ModelSignal<boolean> = model<boolean>(false);

    public onSelect: OutputEmitterRef<void> = output<void>();

    public activate(event: MouseEvent) {
        if (this.disabled() || event.screenY === 0 && event.screenY === 0) {
            return;
        }

        this.onSelect.emit();
        if (this.type() === SelectorType.RADIO && this.selected()) {
            event.preventDefault();
            return;
        }
        this.selected.set(!this.selected());
    }
}
